export default __webpack_public_path__ + "static/media/banner-home2.2a06f140.png";